import React from 'react';

import { InjectedIntl } from 'react-intl';

import EditorLinkIcon from '@atlaskit/icon/glyph/editor/link';
import FileIcon from '@atlaskit/icon/glyph/file';
import FolderFilledIcon from '@atlaskit/icon/glyph/folder-filled';
import { SubmoduleIcon } from '@atlassian/bitkit-icon';

import messages from '../components/directory.i18n';

export const getSourceItemIcon = (type: string, intl: InjectedIntl) => {
  const iconMap: { [key: string]: JSX.Element } = {
    file: <FileIcon label={intl.formatMessage(messages.fileIconLabel)} />,
    directory: (
      <FolderFilledIcon
        label={intl.formatMessage(messages.directoryIconLabel)}
      />
    ),
    submodule: (
      <SubmoduleIcon label={intl.formatMessage(messages.submoduleIconLabel)} />
    ),
    subrepo: (
      <EditorLinkIcon
        label={intl.formatMessage(messages.subrepositoryIconLabel)}
      />
    ),
  };

  return iconMap[type] || iconMap.file;
};
